import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, MapPin, ArrowRight } from "lucide-react";
import { api } from "./api";

const fmtDate = (d) => {
  try { return new Date(d).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return d; }
};

export function EventsPage() {
  const [events, setEvents] = useState(null);
  useEffect(() => { api.get("/events").then((r) => setEvents(r.data)).catch(() => setEvents([])); }, []);

  return (
    <div>
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">/ Upcoming</p>
      <h1 className="mt-3 mb-8 font-oswald text-5xl font-700 uppercase leading-[0.85] tracking-tighter">Events</h1>
      {events === null && <p className="text-zinc-500">Loading…</p>}
      {events?.length === 0 && <p className="text-zinc-500">No events yet. Check back soon.</p>}
      <div className="grid gap-5">
        {events?.map((ev) => (
          <Link key={ev.id} to={`/events/${ev.id}`} data-testid={`event-card-${ev.id}`}
            className="group relative overflow-hidden border border-white/10 bg-ink-900/60 transition-colors hover:border-gold/40">
            <div className="relative h-44 w-full overflow-hidden bg-ink-800">
              {ev.image ? (
                <img src={ev.image} alt={ev.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              ) : (
                <div className="flex h-full items-center justify-center"><Disc /></div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-ink-900 to-transparent" />
            </div>
            <div className="p-5">
              <h3 className="font-oswald text-2xl font-600 uppercase tracking-tight">{ev.title}</h3>
              <div className="mt-2 flex flex-wrap gap-4 text-sm text-zinc-400">
                <span className="flex items-center gap-1.5"><CalendarDays size={14} className="text-gold" /> {fmtDate(ev.date)}</span>
                {ev.location && <span className="flex items-center gap-1.5"><MapPin size={14} className="text-gold" /> {ev.location}</span>}
              </div>
              <span className="mt-4 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-gold">
                Get Tickets <ArrowRight size={14} />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

const Disc = () => <div className="h-16 w-16 rounded-full border-4 border-gold/30" />;
